import { render, staticRenderFns } from "./process-transmittals.vue?vue&type=template&id=91288f08"
import script from "./process-transmittals.vue?vue&type=script&lang=js"
export * from "./process-transmittals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports